import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedTaskAction, updateTaskAction } from '../../../redux/actions/tasksActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import TaskForm from '../forms/TaskForm';

const UpdateTaskModal = ({ readOnly, onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const task = useSelector((state) => state.tasks?.task);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(updateTaskAction(data));
    await dispatch(clearSelectedTaskAction());
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Змінити послугу'}
      loading={loading}
      onClose={onModalClose}
      body={<TaskForm readOnly={readOnly} onSubmit={onSubmit} loading={loading} initTask={task} />}
      actionButton={
        !readOnly && (
          <Button type={'submit'} disabled={loading} variant={'primary'} formId={'task-form'} children={'Змінити'} />
        )
      }
    />
  );
};

export default UpdateTaskModal;
